<div class="gt-filter-container">
  <i class="fa fa-refresh gt-refresh" (click)="refresh()" style="cursor: pointer;" title="Refresh Data"></i>
</div>
<div class="grid-wrapper">
  <div class="grid-header">Efile Grid</div>
  <div class="grid-content">
    @if (rowData?.submission_id) {
<div>Submission Id: {{ rowData.submission_id }}</div>
}
    @if (rowData?.form_id) {
<div>Form Id: {{ rowData.form_id }}</div>
}
    <div class="muted">Grid body renders from configured grid/action route state.</div>
  </div>
</div>

<!--
  Confirmation host for the three legacy `ctrlFn` callbacks ported from
  `ui/app/components/efile/efile.js` (enableDisableScrubbing, sub-sno-disable,
  sub-req-validations). See `EfileCtrlFnDispatcherService`.
-->
<gtw-confirmation-modal
  [config]="confirmModalConfig"
  [visible]="showConfirmModal"
  (confirmed)="onConfirmModal()"
  (cancelled)="onCancelModal()"
  (closed)="onCancelModal()">
</gtw-confirmation-modal>
